import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  IconButton,
  Menu,
  MenuItem,
  Grid,
  InputBase,
  Tooltip,
  Zoom,
  ClickAwayListener,
  Box,
  Typography,
} from '@material-ui/core';
import CustomHourPopup from '../../page/DutyAssign/components/TemplateEdit/CustomHourPopup';
import { TimeIcon } from '../../components/Icon';
import {
  RemarksBgIcon,
  MoreIcon,
  DragIcon,
  BookmarkIcon,
  RemarksIcon,
  HignLightIcon,
  DropUpIcon,
  DropDownIcon,
  DeleteIcon,
} from '../Icon';
import { Dialog } from '../index';
import { i18n } from '../../language';
import lengthVerification from '../../utils/lengthVerification';
import useMobile from '../../utils/useMobile';
import { DialogBody } from '../../page/DutyAssign/components/DutyRoster';
import { store } from '../../redux';
import { authNameE } from '../../utils/userFuncs';
import { onKeyUpEnterOrSpace } from '../../utils';
import Weekly from './Weekly';

const useStylesLongremarkTooltip = makeStyles((theme) => ({
  arrow: {
    color: '#4073d2',
    '&::before': {
      boxShadow: '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)',
    },
  },
  tooltip: {
    borderRadius: '0.625rem',
    boxShadow: '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)',
    backgroundColor: '#4073d2',
    padding: '1.188rem 0.688rem 1.188rem 1.188rem',
    color: theme.palette.font.white,
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    width: '18.125rem',
  },
}));

const useStylesLongremarkTooltipBefore = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.font.white,
    '&::before': {
      boxShadow: '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)',
    },
  },
  tooltip: {
    borderRadius: '0.625rem',
    boxShadow: '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)',
    backgroundColor: theme.palette.font.white,
    padding: '1.188rem 0.688rem 1.188rem 1.188rem',
    color: theme.palette.font.sub,
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    width: '18.125rem',
  },
}));

const useStyles = makeStyles((theme) => ({
  root: {
    width: '16.375rem',
  },
  colorRoot: ({ staffColor, isSort }) => ({
    width: '100%',
    height: '100%',
    padding: '1.063rem 0.625rem 1.063rem 1.25rem',
    borderRadius: '0.625rem',
    boxShadow: '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)',
    backgroundColor: theme.palette.font.white,
    margin: '0 0 0.625rem',
    position: 'relative',
    overflow: 'hidden',
    cursor: isSort === 1 ? 'ns-resize' : 'grab',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '0.312rem',
      height: '100%',
      backgroundColor: staffColor,
      zIndex: '9',
    },
  }),
  name: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.625rem',
    color: theme.palette.font.main,
    fontWeight: '500',
  },
  round: {
    borderRadius: '50%',
    width: '0.5rem',
    height: '0.5rem',
    marginRight: '0.75rem',
    backgroundColor: theme.palette.status.green,
  },
  markiconBtn: {
    borderRadius: '0',
    padding: '0',
    marginLeft: '0.625rem',
    display: 'flex',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  markicon: {
    fontSize: '1.25rem',
    color: '#c0c6cb',
  },
  box: {
    display: 'flex',
    alignItems: 'center',
  },
  dropicon: {
    fontSize: '1.125rem',
    color: '#c0c6cb',
  },
  drop: {
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: '0',
  },
  body: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  remark: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    marginTop: '0.125rem',
  },
  dutytime: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    marginTop: '0.125rem',
  },
  drag: {
    width: '1.782rem',
    height: '1.782rem',
    borderRadius: '0',
    margin: '0 0.781rem 0 -0.188rem',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  dragicon: {
    fontSize: '1.5rem',
    color: '#e1e1e1',
  },
  bookicon: {
    fontSize: '1.438rem',
    color: '#ffab43',
    marginLeft: '1rem',
  },
  dropdown: {
    '& .MuiMenu-paper': {
      boxShadow: '0 0 1rem 0 rgba(125, 134, 169, 0.2)',
    },
    borderRadius: '0.16875rem',
    margin: '4rem 0 0 -6rem',
    '& .MuiPopover-paper': {
      overflow: 'visible',
      '&::before': {
        position: 'absolute',
        top: '-0.688rem',
        left: '50%',
        marginLeft: '-0.688rem',
        content: '""',
        display: 'block',
        borderBottom: '0.688rem solid #fff',
        borderLeft: '0.688rem solid transparent',
        borderRight: '0.688rem solid transparent',
        width: '1.376rem',
        height: '0.688rem',
        zIndex: '10',
      },
      '&::after': {
        position: 'absolute',
        top: '-0.78rem',
        left: '50%',
        marginLeft: '-0.8rem',
        content: '""',
        display: 'block',
        borderBottom: '0.8rem solid rgba(0,0,0,0.03)',
        borderLeft: '0.8rem solid transparent',
        borderRight: '0.8rem solid transparent',
        width: '1.6rem',
        height: '0.8rem',
        zIndex: '0',
      },
    },
  },
  dropitem: {
    padding: '1.25rem 1rem',
    height: '3.75rem',
    width: '15.313rem',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  dropitemBox: {
    display: 'flex',
    width: '100%',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    alignItems: 'center',
  },
  dropitemIcon: {
    fontSize: '1.25rem',
    color: '#000',
    marginRight: '1.062rem',
  },
  high: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  dropupicon: {
    fontSize: '0.875rem',
    color: theme.palette.primary.main,
  },
  highdropdown: {
    margin: '15.2rem 0 0 1.6rem',
    '& .MuiGrid-root': {
      width: '8.75rem',
      padding: '0 0.938rem',
      height: '3.564rem',
    },
    '& .MuiPopover-paper': {
      overflow: 'visible',
      '&::before': {
        position: 'absolute',
        top: '-0.688rem',
        left: '50%',
        marginLeft: '-0.688rem',
        content: '""',
        display: 'block',
        borderBottom: '0.688rem solid #fff',
        borderLeft: '0.688rem solid transparent',
        borderRight: '0.688rem solid transparent',
        width: '1.376rem',
        height: '0.688rem',
        zIndex: '10',
      },
      '&::after': {
        position: 'absolute',
        top: '-0.78rem',
        left: '50%',
        marginLeft: '-0.8rem',
        content: '""',
        display: 'block',
        borderBottom: '0.8rem solid rgba(0,0,0,0.03)',
        borderLeft: '0.8rem solid transparent',
        borderRight: '0.8rem solid transparent',
        width: '1.6rem',
        height: '0.8rem',
        zIndex: '0',
      },
    },
  },
  circleGreen: {
    width: '1.688rem',
    height: '1.688rem',
    borderRadius: '50%',
    backgroundColor: '#c2fcf0',
  },
  circlePurple: {
    width: '1.688rem',
    height: '1.688rem',
    borderRadius: '50%',
    backgroundColor: '#e0e1ff',
  },
  circleYellow: {
    width: '1.688rem',
    height: '1.688rem',
    borderRadius: '50%',
    backgroundColor: '#fffbb9',
  },
  highGridItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  highGridIconbtn: {
    borderRadius: '0',
    padding: '0',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  dialogBodytitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    marginBottom: '0.5635rem',
  },
  dialogBodyinput: {
    width: '100%',
    borderRadius: '0.625rem',
    border: '0.0625rem solid #e4e7eb',
    padding: '1rem 1.25rem 1.063rem 1.25rem',
    marginBottom: '1.875rem',
    '& .MuiInputBase-input': {
      padding: '0',
      fontFamily: 'NotoSans-Medium',
      fontSize: '0.875rem',
      fontWeight: '500',
      color: theme.palette.font.main,
    },
  },
  dialogBodyMultilineinput: {
    width: '100%',
    minHeight: '8.25rem',
    borderRadius: '0.625rem',
    border: '0.0625rem solid #e4e7eb',
    padding: '1.25rem',
    '& .MuiInputBase-input': {
      padding: '0',
      fontFamily: 'NotoSans-Medium',
      fontSize: '0.875rem',
      fontWeight: '500',
      color: theme.palette.font.main,
    },
  },
  temporaryDropDown: {
    '& .MuiMenu-paper': {
      boxShadow: '0 0 1rem 0 rgba(125, 134, 169, 0.2)',
    },
    borderRadius: '0.16875rem',
    '& .MuiPopover-paper': {
      overflow: 'visible',
      '&::before': {
        position: 'absolute',
        top: '-0.688rem',
        right: '1rem',
        marginLeft: '-0.688rem',
        content: '""',
        display: 'block',
        borderBottom: '0.688rem solid #fff',
        borderLeft: '0.688rem solid transparent',
        borderRight: '0.688rem solid transparent',
        width: '1.376rem',
        height: '0.688rem',
        zIndex: '10',
      },
      '&::after': {
        position: 'absolute',
        top: '-0.78rem',
        right: '1rem',
        marginLeft: '-0.688rem',
        content: '""',
        display: 'block',
        borderBottom: '0.8rem solid rgba(0,0,0,0.03)',
        borderLeft: '0.8rem solid transparent',
        borderRight: '0.8rem solid transparent',
        width: '1.6rem',
        height: '0.8rem',
        zIndex: '0',
      },
    },
  },
  dialogBodyContext: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    lineHeight: '1.625rem',
    color: theme.palette.font.main,
    fontWeight: '500',
  },
  input: {
    border: '',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.625rem',
    color: theme.palette.font.main,
    fontWeight: '500',
  },
  label: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#7d86a9',
    marginBottom: '0.625rem',
  },
  errorMsg: {
    margin: '3px 0.825rem 0 0.825rem',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  keyboardTimeInput: {
    paddingRight: '0',
    '& .MuiFormControl-root': {
      display: 'flex',
      justifyContent: 'center',
    },
    height: '3.5rem',
    width: '100%',
  },
  timeIcon: {
    fontSize: '1.25rem',
    color: theme.palette.primary.main,
  },
  markiconBtn2: {
    borderRadius: '4px',
    padding: '0.225rem',
    height: '1.25rem',
    background: '#AAAAAA',
    color: '#FFF',
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
    fontWeight: 'bold',
    fontFamily: 'NotoSans-Bold',
  },
}));

const ColorArr = ['#2e4469', '#FF5B58', '#FFC855', '#8F7CFE', '#3FA7F3'];

function formatCheckTime(checkTime) {
  if (checkTime) {
    if (i18n.locale === 'zh-hk') {
      checkTime = checkTime.replace('am', '上午').replace('pm', '下午');
    }
    return checkTime;
  }
  return '-';
}

export default function StaffCard(props) {
  const {
    name,
    Width,
    light,
    publishCtrl,
    remark,
    longremark,
    number,
    num,
    dragIcon,
    temporary,
    cardList,
    color,
    outlineColour,
    handleDelete,
    handleEditTemporarystaff,
    handleHighlight,
    handleAddRemarks,
    startDate,
    endDate,
    dutyIC,
    dutyICPlaceholder,
    handleInputChange,
    tempId,
    staff,
    rank_code,
    corpId,
    employeeId,
    handleVerify,
    handleEdit,
    id,
    dragProps,
    cardId,
    Rinfo,
    isSort,
    handleSetStartEndTime,
    dutyStartAt,
    dutyEndAt,
    dutyCheckList = [],
    enableSmartComm,
  } = props;
  const classes = useStyles({ staffColor: ColorArr[outlineColour], isSort });
  const [inputName, setInputName] = useState(name);

  useEffect(() => {
    setInputName(name);
  }, [name]);
  const [addSetTimeDialog, setAddSetTimeDialog] = useState(false);
  const index = () => {
    return cardList === undefined
      ? null
      : cardList.findIndex((item) => {
          return item.id === cardId;
        });
  };

  const drag = (props) => {
    if (props) {
      return (
        <IconButton className={classes.drag}>
          <DragIcon className={classes.dragicon} />
        </IconButton>
      );
    }
  };

  const lightBox = (props) => {
    if (props) {
      return <div className={classes.round} />;
    }
  };

  const longremarkclasses = useStylesLongremarkTooltip();
  const longremarkbeforeclasses = useStylesLongremarkTooltipBefore();
  const [toolTipOpen, setToolTipOpen] = useState(false);
  const [isPad] = useMobile();



  const longremarkBox = (props) => {
    const longremarkOpen = Boolean(props);
    if (longremarkOpen) {
      const handleTooltipClose = () => {
        setToolTipOpen(false);
      };
      const handleTooltipOpen = () => {
        isPad && setToolTipOpen(true);
      };
      const toolTipClassInit = () => {
        return publishCtrl && !staff ? longremarkclasses : longremarkbeforeclasses;
      };
      return isPad ? (
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <Tooltip
            classes={toolTipClassInit()}
            title={longremark}
            arrow
            TransitionComponent={Zoom}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            onClose={handleTooltipClose}
            open={toolTipOpen}
          >
            <div
              className={classes.markiconBtn}
              onClick={handleTooltipOpen}
              tabIndex={0}
              onKeyUp={(e) => onKeyUpEnterOrSpace(e, handleTooltipOpen)}
            >
              <RemarksBgIcon className={classes.markicon} />
            </div>
          </Tooltip>
        </ClickAwayListener>
      ) : (
        <Tooltip classes={toolTipClassInit()} title={longremark} arrow TransitionComponent={Zoom}>
          <div className={classes.markiconBtn}>
            <RemarksBgIcon className={classes.markicon} />
          </div>
        </Tooltip>
      );
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [highOpen, setHighOpen] = useState(false);

  const handleHighClick = () => {
    setHighOpen(true);
  };

  const handleHighClose = () => {
    setHighOpen(false);
    setAnchorEl(null);
  };

  const [addRemarkDialog, setaddRemarkDialog] = useState(false);

  const handleAddRemarkDialog = () => {
    setAnchorEl(null);
    setaddRemarkDialog(true);
  };

  const handleAddRemarkDialogClose = () => {
    setdialogremarkValue(remark ?? '');
    setdialoglongremarkValue(longremark ?? '');
    setaddRemarkDialog(false);
  };

  const [dialogremarkValue, setdialogremarkValue] = useState(remark ?? '');

  const handleDialogConfirm = () => {
    handleAddRemarks(index(), dialogremarkValue, dialoglongremarkValue);
    setaddRemarkDialog(false);
    setAnchorEl(null);
    handleEdit(false);
  };

  const [dialoglongremarkValue, setdialoglongremarkValue] = useState(longremark ?? '');

  const handleColorHighLight = (props) => {
    setAnchorEl(null);
    setHighOpen(false);
    if (color === props) {
      handleHighlight(index(), 'White');
      return;
    }
    handleHighlight(index(), props);
    handleEdit(false);
  };
  const handleAddSetTimeDialog = () => {
    setAnchorEl(null);
    setAddSetTimeDialog(true);
  };

  const handleAddSetTimeDialogClose = () => {
    setAddSetTimeDialog(false);
  };
  const drop = (props) => {
    if (props) {
      const roleMap = store.getState()?.roleMap || {};
      return (
        <div>
          <IconButton className={classes.drop} onClick={handleClick} id={`dutyassign_staffCard_dropDown_${id}`}>
            <MoreIcon className={classes.dropicon} />
          </IconButton>
          <Menu className={classes.dropdown} anchorEl={anchorEl} open={open} onClose={handleClose} keepMounted>
            <MenuItem
              className={classes.dropitem}
              onClick={() => {
                handleAddRemarkDialog();
              }}
              id={`dutyassign_staffCard_menuItem_remark_${id}`}
            >
              <div className={classes.dropitemBox}>
                <RemarksIcon className={classes.dropitemIcon} />
                {remark || longremark ? i18n.t('STAFF_DROP_EDIT') : i18n.t('STAFF_DROP_ADD')}
              </div>
            </MenuItem>

            {(roleMap[authNameE.dutyAssign_Edit_Staff_Custom_Work_Hour] || enableSmartComm) && (
              <MenuItem
                className={classes.dropitem}
                onClick={() => {
                  handleAddSetTimeDialog();
                }}
                id={`dutyassign_staffCard_menuItem_setTime_${id}`}
                style={{ borderTop: '0.0625rem solid #e4e7eb' }}
              >
                <div className={classes.dropitemBox}>
                  <TimeIcon className={classes.dropitemIcon} />
                  <div style={{ flexDirection: 'column' }}>
                    <div>{i18n.t('DUTYASSIGN_STAFF_CUSTOMIZE_WORK_HOUR')}</div>
                  </div>
                </div>
              </MenuItem>
            )}
            <MenuItem
              className={classes.dropitem}
              style={{ borderTop: '0.0625rem solid #e4e7eb', borderBottom: '0.0625rem solid #e4e7eb' }}
              onClick={() => {
                handleHighClick();
              }}
              id={`dutyassign_staffCard_menuItem_hignLight_${id}`}
            >
              <div className={classes.dropitemBox}>
                <HignLightIcon className={classes.dropitemIcon} style={{ fontSize: '1.25rem' }} />
                <div className={classes.high}>
                  {i18n.t('STAFF_DROP_HIGHLIGHT')}
                  <Box display="flex" alignItems="center">
                    {highOpen ? (
                      <DropUpIcon className={classes.dropupicon} />
                    ) : (
                      <DropDownIcon className={classes.dropupicon} />
                    )}
                  </Box>
                </div>
              </div>
            </MenuItem>
            <MenuItem
              className={classes.dropitem}
              onClick={() => {
                handleDelete(index());
                handleClose();
                handleEdit(false);
              }}
              id={`dutyassign_staffCard_menuItem_delete_${id}`}
            >
              <div className={classes.dropitemBox}>
                <DeleteIcon className={classes.dropitemIcon} style={{ fontSize: '1rem', marginLeft: '0.2rem' }} />
                {i18n.t('STAFF_TEMPORARY_DELETE')}
              </div>
            </MenuItem>
          </Menu>
          <Menu
            className={classes.highdropdown}
            anchorEl={anchorEl}
            open={highOpen}
            onClose={handleHighClose}
            keepMounted
          >
            <Grid container className={classes.highGrid} spacing={2}>
              <Grid item xs={4} className={classes.highGridItem}>
                <IconButton
                  className={classes.highGridIconbtn}
                  onClick={() => {
                    handleColorHighLight('Green');
                  }}
                  id={`dutyassign_staffCard_menuItem_hignLight_green_${id}`}
                >
                  <div className={classes.circleGreen} />
                </IconButton>
              </Grid>
              <Grid item xs={4} className={classes.highGridItem}>
                <IconButton
                  className={classes.highGridIconbtn}
                  onClick={() => {
                    handleColorHighLight('Purple');
                  }}
                  id={`dutyassign_staffCard_menuItem_hignLight_purple_${id}`}
                >
                  <div className={classes.circlePurple} />
                </IconButton>
              </Grid>
              <Grid item xs={4} className={classes.highGridItem}>
                <IconButton
                  className={classes.highGridIconbtn}
                  onClick={() => {
                    handleColorHighLight('Yellow');
                  }}
                  id={`dutyassign_staffCard_menuItem_hignLight_yellow_${id}`}
                >
                  <div className={classes.circleYellow} />
                </IconButton>
              </Grid>
            </Grid>
          </Menu>
          {addSetTimeDialog && (
            <CustomHourPopup
              open={addSetTimeDialog}
              closePop={handleAddSetTimeDialogClose}
              dutyStartAt={dutyStartAt}
              dutyEndAt={dutyEndAt}
              confirmClick={handleSetStartEndTime}
              itemIndex={index()}
            />
          )}
          <Dialog
            open={addRemarkDialog}
            handleClose={handleAddRemarkDialogClose}
            handleCancel={handleAddRemarkDialogClose}
            handleConfirm={handleDialogConfirm}
            title={remark || longremark ? i18n.t('STAFF_DROP_EDIT') : i18n.t('STAFF_DROP_ADD')}
            cancel={i18n.t('DUTYASSIGN_CANCEL')}
            confirm={i18n.t('DUTYASSIGN_CONFIRM')}
            cancelID="DutyAssign-Dialog-remark-cancel"
            confirmID="DutyAssign-Dialog-remark-confirm"
            closeID="DutyAssign-Dialog-remark-close"
          >
            <div className={classes.dialogBodytitle}>{i18n.t('STAFF_DROP_SHORT_REMARKS_TITLE')}</div>
            <InputBase
              className={classes.dialogBodyinput}
              placeholder={i18n.t('STAFF_DROP_REMARKS_INPUT')}
              value={dialogremarkValue}
              onChange={(event) => {
                if (lengthVerification(event.target.value, 26)) {
                  return;
                }
                setdialogremarkValue(event.target.value);
              }}
              id="DutyAssign-Dialog-short-remark-input"
            />
            <div className={classes.dialogBodytitle}>{i18n.t('STAFF_DROP_LONG_REMARKS_TITLE')}</div>
            <InputBase
              className={classes.dialogBodyMultilineinput}
              multiline
              rows="5"
              placeholder={i18n.t('STAFF_DROP_LONG_REMARKS_INPUT')}
              value={dialoglongremarkValue}
              onChange={(event) => {
                if (lengthVerification(event.target.value, 256)) {
                  return;
                }
                setdialoglongremarkValue(event.target.value);
              }}
              id="DutyAssign-Dialog-long-remark-input"
            />
          </Dialog>
        </div>
      );
    }
  };

  const [temporaryAnchorEl, setTemporaryAnchorEl] = useState(null);
  const temporaryOpen = Boolean(temporaryAnchorEl);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);

  const [editName, setEditName] = useState(name);
  const [rankValue, setRankValue] = useState(rank_code);
  const [editCorpId, setEditCorpId] = useState(corpId);
  const [editEmployeeId, setEditEmployeeId] = useState(employeeId);
  const [editStartTime, setEditStartTime] = useState(startDate);
  const [editEndTime, setEditEndTime] = useState(endDate);
  const [error, setError] = useState({});

  const numberToTime = (duration) => {
    const minutes = Math.floor((duration / (1000 * 60)) % 60);
    const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    const hourStr = hours < 10 ? `0${hours}` : `${hours}`;
    const minuteStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
    return `${hourStr}:${minuteStr}`;
  };

  const remarkBox = (props) => {
    if (props) {
      return <div className={classes.remark}>{props}</div>;
    }
  };

  const dutyTimeBox = (dutyStartTime, dutyEndTime) => {
    if ((dutyStartTime || dutyStartTime === 0) && dutyEndTime) {
      const chatEndAtString = () => {
        if (numberToTime(dutyEndTime) === '00:00') {
          return '24:00';
        } else {
          return numberToTime(dutyEndTime);
        }
      };
      const startEndTime = `${numberToTime(dutyStartTime)} - ${chatEndAtString()}`;
      return <div className={classes.dutytime}>{startEndTime}</div>;
    }
  };

  const numberBox = (props) => {
    if (props) {
      return <div className={classes.name}>{`${name} (${number})`}</div>;
    }
    return dutyIC ? (
      <InputBase
        className={classes.input}
        id={`dutyassing_dutyIC_${id}`}
        placeholder={dutyICPlaceholder ?? ''}
        value={inputName}
        multiline
        disabled={!publishCtrl}
        onChange={(event) => {
          if (lengthVerification(event.target.value, 21)) {
            return;
          }
          setInputName(event.target.value);
          handleInputChange(event.target.value);
        }}
      />
    ) : (
      <div className={classes.name} title={tempId ? name : undefined}>
        {name}
      </div>
    );
  };

  const bookmark = (props) => {
    if (props) {
      return <BookmarkIcon className={classes.bookicon} />;
    }
  };

  const backgroundColor = (props) => {
    switch (props) {
      case 'White':
        return '#ffffff';
      case 'Yellow':
        return '#fff8be';
      case 'Green':
        return '#c2fcf0';
      case 'Purple':
        return '#e0e1ff';
      default:
        break;
    }
  };

  const handleOnClick = (att) => {
    switch (att) {
      case 'ATT':
        window.postMessage({
          topic: 'checkio',
          action: 'ci',
          request: {
            corpId,
            tempId,
            name,
          },
        });
        break;
      case 'IN':
        window.postMessage({
          topic: 'checkio',
          action: 'co',
          request: {
            corpId,
            tempId,
            name,
          },
        });
        break;
      default:
        break;
    }
  };

  let att;
  let attColor;
  let attTitle;
  let attLabel;
  const staffKey = `${corpId} ${name}`;
  dutyCheckList.forEach((el) => {
    if (`${el.corpId} ${el.staffName}` === staffKey) {
      const status = `${el.status}`.toLowerCase();
      switch (status) {
        case 'not on duty':
          att = 'ATT';
          attLabel = i18n.t('DUTYASSIGN_ATTENDANCE_CLOCK_STATUS_ATT');
          attTitle = <Typography>{i18n.t('DUTYASSIGN_ATTENDANCE_CLOCK_STATUS_ATT_FULL')}</Typography>;
          break;
        case 'clock-in':
          att = 'IN';
          attLabel = i18n.t('DUTYASSIGN_ATTENDANCE_CLOCK_STATUS_IN');
          attColor = '#28D2AB';
          attTitle = (
            <div style={{ fontSize: '1.5em', display: 'flex' }}>
              <Box>{i18n.t('DUTYASSIGN_ATTENDANCE_CLOCK_STATUS_IN_FULL')}</Box>
              <Box>{`: ${formatCheckTime(el.checkinTime)}`}</Box>
            </div>
          );
          break;
        case 'clocked-out':
          att = 'OUT';
          attLabel = i18n.t('DUTYASSIGN_ATTENDANCE_CLOCK_STATUS_OUT');
          attColor = '#7B80FF';
          attTitle = (
            <div style={{ fontSize: '1.5em', display: 'flex' }}>
              <div>
                <Box>{i18n.t('DUTYASSIGN_ATTENDANCE_CLOCK_STATUS_IN_FULL')}</Box>
                <Box mt="0.2rem">{i18n.t('DUTYASSIGN_ATTENDANCE_CLOCK_STATUS_OUT_FULL')}</Box>
              </div>
              <div>
                <Box>{`: ${formatCheckTime(el.checkinTime)}`}</Box>
                <Box mt="0.2rem">{`: ${formatCheckTime(el.checkoutTime)}`}</Box>
              </div>
            </div>
          );
          break;
        default:
          break;
      }
      return false;
    }
  });

  return (
    <div
      className={classes.root}
      style={{ width: Width }}
      {...dragProps}
      // ref={publishCtrl ? drag : null}
    >
      <div className={classes.colorRoot} style={{ backgroundColor: backgroundColor(color), height: '100%' }}>
        <div className={classes.body}>
          <div className={classes.box}>
            {drag(dragIcon)}
            {lightBox(light)}
            {numberBox(num)}
            {longremarkBox(longremark)}
            {bookmark(temporary)}
          </div>
          <Box display="flex" alignItems="center">
            {!staff && att && (
              <Tooltip title={attTitle} placement="top-start" arrow>
                <div
                  className={classes.markiconBtn2}
                  style={{ backgroundColor: attColor, width: 36.3, cursor: 'pointer', marginRight: '-0.4em' }}
                  id={`quick_clock_in_out_${id}`}
                  onClick={() => handleOnClick(att)}
                  tabIndex={0}
                  onKeyUp={(e) => onKeyUpEnterOrSpace(e, () => handleOnClick(att))}
                >
                  {attLabel}
                </div>
              </Tooltip>
            )}
            {Rinfo && <Weekly Rinfo={Rinfo} />}
            {drop(publishCtrl && !staff)}
            {temporary && (
              <>
                <IconButton
                  className={classes.drop}
                  onClick={(event) => {
                    setTemporaryAnchorEl(event.currentTarget);
                  }}
                  id={`dutyassign-roster-temp-drop-${id}`}
                >
                  <MoreIcon className={classes.dropicon} />
                </IconButton>
                <Menu
                  className={classes.temporaryDropDown}
                  anchorEl={temporaryAnchorEl}
                  open={temporaryOpen}
                  onClose={() => {
                    setTemporaryAnchorEl(null);
                  }}
                  keepMounted
                >
                  <MenuItem
                    className={classes.dropitem}
                    onClick={() => {
                      setEditOpen(true);
                    }}
                    id={`dutyassign-roster-temp-menuItem-edit-${id}`}
                  >
                    <div className={classes.dropitemBox}>
                      <RemarksIcon className={classes.dropitemIcon} style={{ color: '#000000' }} />
                      {i18n.t('STAFF_TEMPORARY_EDIT')}
                    </div>
                  </MenuItem>
                  <MenuItem
                    className={classes.dropitem}
                    onClick={() => {
                      setDeleteOpen(true);
                    }}
                    id={`dutyassign-roster-temp-menuItem-delete-${id}`}
                    style={{ borderTop: 'solid 1px #e4e7eb' }}
                  >
                    <div className={classes.dropitemBox}>
                      <DeleteIcon className={classes.dropitemIcon} style={{ color: '#2e4469' }} />
                      {i18n.t('STAFF_TEMPORARY_DELETE')}
                    </div>
                  </MenuItem>
                </Menu>
                {editOpen && (
                  <Dialog
                    title={i18n.t('STAFF_TEMPORARY_EDIT_TITLE')}
                    cancel={i18n.t('DUTYASSIGN_CANCEL')}
                    confirm={i18n.t('DUTYASSIGN_CONFIRM')}
                    cancelID="DutyAssign-Dialog-adk-cancel"
                    confirmID="DutyAssign-Dialog-adk-confirm"
                    closeID="DutyAssign-Dialog-adk-close"
                    open={editOpen}
                    handleClose={() => {
                      setEditOpen(false);
                      setEditName(name);
                      setError({});
                      setRankValue(rank_code);
                      setEditCorpId(corpId);
                      setEditEmployeeId(employeeId);
                      setEditStartTime(startDate);
                      setEditEndTime(endDate);
                    }}
                    handleCancel={() => {
                      setEditOpen(false);
                      setEditName(name);
                      setError({});
                      setRankValue(rank_code);
                      setEditCorpId(corpId);
                      setEditEmployeeId(employeeId);
                      setEditStartTime(startDate);
                      setEditEndTime(endDate);
                    }}
                    handleConfirm={() => {
                      if (handleVerify({ name: editName, rank: rankValue, from: editStartTime, to: editEndTime })) {
                        return;
                      }
                      handleEditTemporarystaff(
                        tempId,
                        editEndTime,
                        editName,
                        editStartTime,
                        rankValue,
                        editCorpId,
                        editEmployeeId
                      );
                      setError({});
                      setEditOpen(false);
                      setTemporaryAnchorEl(null);
                    }}
                    confirmStyle={{
                      opacity: handleVerify({ name: editName, rank: rankValue, from: editStartTime, to: editEndTime })
                        ? 0.2
                        : 1,
                    }}
                  >
                    <DialogBody
                      rankValue={rankValue}
                      handleRank={setRankValue}
                      inputValue={editName}
                      handleInput={setEditName}
                      corpId={editCorpId}
                      handleCorpId={setEditCorpId}
                      employeeId={editEmployeeId}
                      handleEmployeeId={setEditEmployeeId}
                      startTime={editStartTime}
                      handleStartTime={setEditStartTime}
                      endTime={editEndTime}
                      handleEndTime={setEditEndTime}
                      error={error}
                      setError={setError}
                    />
                  </Dialog>
                )}
                {deleteOpen && (
                  <Dialog
                    title={i18n.t('STAFF_TEMPORARY_DELETE_TITLE')}
                    cancel={i18n.t('DUTYASSIGN_CANCEL')}
                    confirm={i18n.t('DUTYASSIGN_CONFIRM')}
                    cancelID="DutyAssign-Dialog-adk-cancel"
                    confirmID="DutyAssign-Dialog-adk-confirm"
                    closeID="DutyAssign-Dialog-adk-close"
                    open={deleteOpen}
                    handleClose={() => {
                      setDeleteOpen(false);
                    }}
                    handleCancel={() => {
                      setDeleteOpen(false);
                    }}
                    handleConfirm={() => {
                      handleDelete();
                      setDeleteOpen(false);
                      setTemporaryAnchorEl(null);
                    }}
                  >
                    <div className={classes.dialogBodyContext}>{i18n.t('STAFF_TEMPORARY_DELETE_BODY')}</div>
                  </Dialog>
                )}
              </>
            )}
          </Box>
        </div>
        {dutyTimeBox(dutyStartAt, dutyEndAt)}
        {remarkBox(remark)}
      </div>
    </div>
  );
}
